import { connectRefinementList } from "react-instantsearch-dom"

// https://www.algolia.com/doc/guides/building-search-ui/widgets/customize-an-existing-widget/react/#virtual-widgets
const VirtualRefinementList = connectRefinementList(() => null)

const VirtualRefinements = ({
	categoryId,
	isBrandCategory,
	brandName,
	parsedInitialFilterValues,
}: Props) => {
	if (isBrandCategory)
		return <VirtualRefinementList attribute="manufacturer" defaultRefinement={[brandName]} />

	return (
		<>
			<VirtualRefinementList attribute="categoryIds" defaultRefinement={[categoryId]} />
			{Object.entries(parsedInitialFilterValues?.refinementList ?? {}).map(
				([attribute, refinements]) => {
					return (
						<VirtualRefinementList
							key={attribute}
							attribute={attribute}
							defaultRefinement={refinements}
						/>
					)
				},
			)}
		</>
	)
}

interface Props {
	categoryId: string
	isBrandCategory: boolean
	brandName: string
	parsedInitialFilterValues: qs.ParsedQs
}

export default VirtualRefinements
